/**
 * SMS Count Service
 * Service for fetching inbound SMS count based on user type
 */

import { graphqlClient } from '@/services/core/graphqlClient';
import { SMS_QUERIES } from '@/services/resources/smsGquery';

export interface SMSCountResponse {
  api_sms_aggregate: {
    aggregate: {
      count: number;
    };
  };
}

class SMSCountService {
  /**
   * Get SMS count for admin users (PA, CA, EA)
   */
  async getSMSCountForAdmin(token: string) {
    const response = await graphqlClient.query<SMSCountResponse>(
      SMS_QUERIES.GET_SMS_COUNT_ADMIN,
      {},
      token
    );

    if (!response.success || !response.data) {
      throw new Error(response.errors?.[0] || 'Failed to fetch SMS count for admin');
    }

    return response.data.api_sms_aggregate.aggregate.count;
  }

  /**
   * Get SMS count for regular users
   */
  async getSMSCountForUser(userId: number, token: string) {
    const response = await graphqlClient.query<SMSCountResponse>(
      SMS_QUERIES.GET_SMS_COUNT_USER,
      { loggedInUserID: userId },
      token
    );

    if (!response.success || !response.data) {
      throw new Error(response.errors?.[0] || 'Failed to fetch SMS count for user');
    }

    return response.data.api_sms_aggregate.aggregate.count;
  }
}

export const smsCountService = new SMSCountService();
export default smsCountService;